import React, { useState, useEffect } from 'react'
import { InjuryTable, Inner, TeamCol } from './styles'
import { PageContainerMain, Box } from '../../Components/Layout'
import { CURRENT_YEAR } from '../../Config/League/league.config'
import { fetchAllPlayerForInjuries, PlayerDataGQL } from '../../Api'
import { Spinner } from '../../Components/Icons'
import { createUrl } from '../../Routing/urls'
import { logEvent, getTeamIc } from '../../Utils'
import { colors } from '../../Components/consts'
import { Con } from '../../Components/Layout/Containers/ConStyles'
import { AdUnit } from '../../Components/Ads/AdUnit'
import { Img } from '../../Components/Image/Img'
import { Lk } from '../../Components/Links/Lk'
import { TableHeader } from '../../Components/Tables/TableHeader'

const InjuryReport: React.FC<React.PropsWithChildren<unknown>> = () => {
  const [players, setPlayers] = useState<PlayerDataGQL[]>([])
  const [loading, setLoading] = useState<boolean>(true)


  useEffect(() => {
    fetchPlayersWithInjuries().then((plrs) => {
      const sorted = plrs.sort((a, b) => {
        const textA = b.currentTeam.officialId.toUpperCase()
        const textB = a.currentTeam.officialId.toUpperCase()
        return textB < textA ? -1 : textB > textA ? 1 : 0
      })
      setPlayers(sorted)
      setLoading(false)
    })
  }, [])

  const log = (event: string, slug: string) => {
    logEvent(event, {
      section: 'injury_report_page',
      player: slug,
    })
  }

  const fetchPlayersWithInjuries = async () => {
    const playerRes = await fetchAllPlayerForInjuries('regular', CURRENT_YEAR)
    const plrs = playerRes?.allPlayers
    if (!plrs) return []
    if (plrs.length > 1) {
      let injuryList: PlayerDataGQL[] = []
      plrs.map((p) => {
        if (!p.currentTeam?.injuryStatus || p.currentTeam.officialId === 'ZPP') return
        if (
          p.currentTeam.injuryStatus.toLowerCase() !== 'h' &&
          p.currentTeam?.injuryStatus?.toLowerCase() !== 'na'
        ) {
          injuryList.push(p)
          return
        }
      })
      return injuryList
    }
    return []
  }

  return (
    <PageContainerMain>
      <Box noMargin>
      <AdUnit bannerType="bannerMain" aria-label="Injury Report page ad header" />
        <Inner>
        <h1>Official PLL Injury Report</h1>
        <Con justify='center' noMargin noPadding>
          {loading && (
            <>
              <Spinner fill={colors.yellow}  width={30} height={30}/>
              Loading...
            </>
          )}
          {!loading && players.length > 0 && (
            <InjuryTable>
              <thead>
                <tr>
                  <TableHeader ariaLabel="No Value"></TableHeader>
                  <TableHeader ariaLabel="Status">Status</TableHeader>
                  <TableHeader ariaLabel="Description">Desc</TableHeader>
                </tr>
              </thead>
              <tbody>
                {players.map((pl) => (
                  <tr key={pl.officialId}>
                    <td>
                      <Lk
                        link={createUrl('player', {
                          firstName: pl.firstName,
                          lastName: pl.lastName,
                          slugName: pl.slug,
                          tab: 'profile',
                          year: CURRENT_YEAR,
                        })}
                        alt={`${pl.firstName} ${pl.lastName} profile`}
                      >
                        <TeamCol>
                          <Img
                            src={getTeamIc(pl.currentTeam.fullName)}
                            alt={`${pl.currentTeam.fullName} logo`}
                          />
                          <span onClick={() => log('injury_report_click', pl.slug)}>
                            {pl.firstName} {pl.lastName} | {pl.currentTeam.position}
                          </span>
                        </TeamCol>
                      </Lk>
                    </td>
                    <td>{pl.currentTeam.injuryStatus}</td>
                    <td>{pl.currentTeam.injuryDescription}</td>
                  </tr>
                ))}
              </tbody>
            </InjuryTable>
          )}
          {!loading && players.length < 1 && (
            <InjuryTable>
              <tbody>
                <tr>No player injuries.</tr>
              </tbody>
            </InjuryTable>
          )}
        </Con>
        </Inner>
        <AdUnit bannerType="bannerSecond" aria-label="Injury Report page ad footer" />
      </Box>
    </PageContainerMain>
  )
}

export default InjuryReport
